"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleSalesDefaultSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleSalesDefaultSchema extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: 'FreeModuleModalSalesDefaultButton' });
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_DEFAULT;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.ClickFreeModuleSalesDefaultSchema = ClickFreeModuleSalesDefaultSchema;
